import { Button } from "@mui/material";
import Colors from "@src/constants/Colors";
import styled from "styled-components";

export const StyledButton = styled(Button)`
  &.MuiButtonBase-root {
    padding: 14px 16px;
    font-family: "Ringside Regular-Book";
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    text-transform: capitalize;
    height: 40px;
    box-shadow: none;
    background-color: ${Colors.secondary};
    gap: 8px;
    border-radius: 8px;

    &:hover {
      background-color: ${Colors.secondary};
      box-shadow: none;
    }
  }
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  flex-direction: column;
  min-height: 180px;

  p {
    font-family: "Ringside Regular-Light";
    margin: 0 0 18px 0;
    font-size: 14px;
    line-height: 20px;
  }
`;

export const LoadingWrapper = styled.div`
  width: 100%;
`;
